/** Maps a local monotonic clock into the hub's session-relative time domain. */
export class HostRelativeClock {
    #monotonicNow;
    #anchor;
    constructor(monotonicNow) {
        this.#monotonicNow = monotonicNow;
    }
    anchor(hostTime) {
        if (!Number.isFinite(hostTime) || hostTime < 0)
            return false;
        const current = this.#anchor;
        if (current !== undefined && hostTime <= current.hostTime)
            return hostTime === current.hostTime;
        const localTime = this.#monotonicNow();
        if (!Number.isFinite(localTime))
            return false;
        this.#anchor = { hostTime, localTime };
        return true;
    }
    get anchored() {
        return this.#anchor !== undefined;
    }
    reset() {
        this.#anchor = undefined;
    }
    createdAt() {
        const anchor = this.#anchor;
        if (anchor === undefined)
            throw new Error("whiteboard host-time anchor is unavailable");
        const localTime = this.#monotonicNow();
        if (!Number.isFinite(localTime))
            throw new Error("whiteboard local monotonic clock is invalid");
        const createdAt = anchor.hostTime + Math.max(0, localTime - anchor.localTime);
        if (!Number.isFinite(createdAt))
            throw new Error("whiteboard host-relative timestamp is invalid");
        return createdAt;
    }
}
//# sourceMappingURL=clock.js.map